import { DateTime } from "luxon";
import type { DateRange } from "react-day-picker";
import type { TimePeriodsValue, StructureTimePeriodsValue } from "@/config/date";

export function getDateRangeFromTimePeriod(value: TimePeriodsValue | StructureTimePeriodsValue): DateRange | undefined {
	const now = DateTime.now().endOf("day");

	let from: DateTime;
	switch (value) {
		case "last24h":
			from = now.minus({ hours: 24 });
			break;
		case "last7d":
			from = now.minus({ days: 7 });
			break;
		case "last14d":
			from = now.minus({ days: 14 });
			break;
		case "last30d":
			from = now.minus({ days: 30 });
			break;
		case "last90d":
			from = now.minus({ days: 90 });
			break;
		case "last1y":
			from = now.minus({ years: 1 });
			break;
		case "last10y":
			from = now.minus({ years: 10 });
			break;
		default:
			return undefined;
	}

	return {
		from: from.toJSDate(),
		to: now.toJSDate(),
	};
}
